import '~/assets/scss/bpif.scss'

import getSwiperSlider from '~/js/modules/slider';
import Accordion from '~/js/modules/accordion';
import SwitchStock from '~/js/modules/switch-stock';
import '~/js/modules/switches';
import Filters from '~/js/modules/filters';

window.addEventListener(`DOMContentLoaded`, () => {
  const bannersSlider = document.querySelector(`.banners__slider`);
  const newsSlider = document.querySelector(`.news__slider`);
  const accordions = document.querySelectorAll(`.accordion`);
  const stock = document.querySelectorAll(`.js-stocks-container`);

  if (accordions.length) {
    accordions.forEach((accordion) => {
        if(!accordion.classList.contains('main-nav__list')) {
            new Accordion(accordion)
        }
    });
  }

  const interleaveOffset = 0.5;

  const bannersSwiperParams = {
    speed: 1000,
    slidesPerView: 1,
    loop: true,
    loopAdditionalSlides: 3,
    watchSlidesProgress: true,
    autoplay: {
      delay: 6000,
      waitForTransition: false,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: `.banners .slider-arrows__arrow--next`,
      prevEl: `.banners .slider-arrows__arrow--prev`,
    },
    pagination: {
      el: `.slider-dots`,
      clickable: true,
      bulletClass: `slider-dots__dot`,
      bulletActiveClass: `active`,
      renderBullet(index, className) {
        return `
        <button class="${className}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="25"></circle>
          </svg>
        </button>`;
      },
    },
    on: {
      progress() {
        for (let i = 0; i < this.slides.length; i++) {
          const slideProgress = this.slides[i].progress;
          const innerOffset = this.width * interleaveOffset;
          const innerTranslate = slideProgress * innerOffset;
          this.slides[i].querySelector(`.slider-top__image`).style.transform = `translate3d(` + innerTranslate + `px, 0, 0)`;
        }
      },
      touchStart() {
        this.autoplay.stop();
        for (let i = 0; i < this.slides.length; i++) {
          this.slides[i].style.transition = ``;
        }
      },
      touchEnd() {
        this.autoplay.start();
      },
      slideChange() {
        const currentIndex = this.realIndex < 10
          ? `0${this.realIndex + 1}`
          : `${this.realIndex + 1}`;
        this.el.querySelector(`.slider-pages__page--current`).textContent = currentIndex;
      },
      setTransition(speed) {
        for (let i = 0; i < this.slides.length; i++) {
          this.slides[i].style.transition = speed + `ms`;
          this.slides[i].querySelector(`.slider-top__image`).style.transition = speed + `ms`;
        }
      },
    },
  };

  const newsSwiperParams = {
    slidesPerView: `auto`,
    loop: false,
    autoplay: false,
    navigation: {
      nextEl: `.news .slider-arrows__arrow--next`,
      prevEl: `.news .slider-arrows__arrow--prev`,
      disabledClass: `disabled`,
    },
    pagination: false,
  };

  if (bannersSlider) {
    getSwiperSlider(bannersSlider, bannersSwiperParams);
  }

  if (newsSlider) {
    getSwiperSlider(newsSlider, newsSwiperParams);
  }

  if (stock && window.innerWidth < 768) {
    new SwitchStock({container: 'stocksA', mode: 'slider'});
  }

  const filtersControls = document.querySelectorAll(`.js-filters-controls`);
  if (filtersControls.length) {
    filtersControls.forEach((fc) => {
      new Filters(fc);
    });
  }
});
